import * as React from "react";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  activityOptions,
  entityData,
  entityTypeOptions,
  platformOptions,
  profileOptions,
} from "../../data";

import RegisterHeaderTab from "./RegisterHeaderTab";

export default function CenteredTabs() {
  // const dispatch = useDispatch()
  // const navigate = useNavigate();

  const {loading} = useSelector(state => state.auth)

  const allQuestions = [
    profileOptions,
    activityOptions,
    entityTypeOptions,
    entityData,
    platformOptions,
  ];
  const [value, setValue] = React.useState(0);
  const [block, setBlock] = React.useState(0);
  const currentQuestion = allQuestions[block];
  const [details, setDetails] = React.useState([]);

  const dispatch = useDispatch();

  const uniqueDetails = [...new Set(details)];


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { translate } = useSelector((state) => state);
  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);
  const navigate = useNavigate();

  React.useEffect(() => {
    setValue(block);
  }, [block]);

  return (
    <div
      style={{
        minHeight: "97vh",
      }}
    >
      {/* Tabs */}
      <RegisterHeaderTab
        t={t}
        allQuestions = {allQuestions}
        handleChange={handleChange}
        navigate={navigate}
        value={value}
      />
    </div>
  );
}
